import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CFCreateModalSF from '../../../components/superUser/transaction/CFCreateModalSF'
import TransactionNavUI from '../../../components/superUser/transaction/TransactionNavUI'
import './CashFlow2Page.css'

const CashFlow2PageUI = ({ context, account, subTotalList, yearMonthList, onRefreshClick,
  createMode, onCreateClick, onCancelClick,
  updateMode, onUpdateClick, selectedCashFlow
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cf2' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w1000'
    centered={!account} account={account} page='cashFlow2'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Cash Flow</b></span>
            </span>
          }
          right={<span />}
        />

        <TransactionNavUI account={account} page='cashFlow2' />

        <CashFlow2UI
          context={context}
          createMode={createMode}
          onCreateClick={onCreateClick}
          subTotalList={subTotalList}
          yearMonthList={yearMonthList}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
          updateMode={updateMode}
          selectedCashFlow={selectedCashFlow}
        />
      </div>
    }

    <CFCreateModalSF context={context} account={account} createMode={createMode}
      onCancelClick={onCancelClick} onRefreshClick={onRefreshClick}
      updateMode={updateMode} selectedCashFlow={selectedCashFlow}
    />

  </SuperUserAccountPageUI>


const CashFlow2UI = ({ context, subTotalList, yearMonthList }) =>
  <CardUI className='scroll'>
    <table>
      <thead>
        <th className='g_sticky_left'></th>
        {
          yearMonthList && yearMonthList.map((yearMonth) =>
            <th className='g_no_wrap_2'>{yearMonth}</th>
          )
        }
      </thead>
      <tbody>
        {
          subTotalList && subTotalList.map((subTotal) =>
            <>
              <tr>
                <td className='g_no_wrap_2 g_sticky_left name'><b>{subTotal.subTotalName}</b></td>
                {
                  subTotal.monthlyAmountDTOList && subTotal.monthlyAmountDTOList.map((monthlyAmount) =>
                    <td className='amount'>{monthlyAmount.amountF5}</td>
                  )
                }
              </tr>
              {
                subTotal.txnTypeList.map((txnType) =>
                  <tr>
                    <td className='g_no_wrap_2 g_sticky_left name'>{txnType.txnTypeName}</td>
                    {
                      txnType.monthlyAmountDTOList && txnType.monthlyAmountDTOList.map((monthlyAmount) =>
                        <td className='amount'>{monthlyAmount.amountF5}</td>
                      )
                    }
                  </tr>
                )
              }
            </>
          )
        }
      </tbody>
    </table>
  </CardUI>

export default CashFlow2PageUI
